import BaseApi from './baseApi';
import IAuthentication from '../models/IAuthentication';
import { createDataAccessStore } from '@/store/stores/DataAcess-store';
import { StringObjectArrayListTuple, StringObjectTuple } from '../types/types';
import DataAcessApi from './DataAccessApi';
import { BORInboundsDetail } from '../models/BORInboundParse';
import IBORInboundDetailType from '../models/IBORInboundDetailType';
import IDataTable from '../models/IDataTable';
import BORTransactionsApi from './BORTransactionsApi';
import { BORValidation } from '../models/BORValidation';
export default class BORInboundsDetailApi extends BaseApi {
    idUser : string = "";
    dataAcess: any = null;
    borTransactionsApi: BORTransactionsApi;

    constructor() {
        super("dataaccess", "Inbounds");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.dataAcess = createDataAccessStore('dataAcessInboundMain');
        this.dataAcess.FormId = "Inbounds";
        this.borTransactionsApi = new BORTransactionsApi();
    }

    async InsertParsedDetail(BORInboundsDetail: BORInboundsDetail, idCompany: string, idInbound: string) : Promise<boolean> {
        let result: any[][] = this.extractValues(BORInboundsDetail.inboundDetails);
        let parameters : StringObjectTuple[];
        parameters = [['IdTransaction', BORInboundsDetail.idTransaction], ['IdCompany', idCompany], ['IdInbound', idInbound], ['CreatedBy', this.idUser]];
        let structures : StringObjectArrayListTuple[];
        structures = [["InboundDetail", result]];
        const api = new DataAcessApi("Inbounds3");
        try {
            await api.ExecStructuredProcedure('BOR_INBOUND_INSERT_PARSED_DETAIL', parameters, structures);
            await this.borTransactionsApi.UpdatedParse(BORInboundsDetail.idTransaction, 0, '');
        } catch (error) {
            await this.borTransactionsApi.UpdatedParse(BORInboundsDetail.idTransaction, 500, this.ParseToString(error));
            console.error('Error adding fields:', error);
            return false;
        }
        return true;
    }
    
    async ReadAll(idInbound: string, idTransaction: string): Promise<IBORInboundDetailType[]> {
        let parameters : StringObjectTuple[];
        parameters = [['IdInbound', idInbound], ['idTransaction', idTransaction]];
        const api = new DataAcessApi("Inbounds4");
        try {
            const data: IDataTable = await api.ExecStructuredProcedure("BOR_INBOUND_READ_ALL", parameters, []);
            return this.MapToBORInboundDetailType(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    async DeleteDetail(idInboundDetail: string, idTransaction: string): Promise<void> {
        let parameters : StringObjectTuple[];
        parameters = [['idTransaction', idTransaction], ['Id', idInboundDetail], ['user', this.idUser]];
        const api = new DataAcessApi("Inbounds5");
        try {
            await api.ExecStructuredProcedure("BOR_INBOUND_DELETE_DETAIL", parameters, []);
        } catch (error) {
            console.error('Error deleting fields:', error);
        }
    }

    async UpdateDetail(BORInboundDetails: IBORInboundDetailType[], idTransaction: string): Promise<boolean> {
        let result: any[][] = [];

        BORInboundDetails.forEach((detail) => {
            // --- Cálculo seguro de totalGoods ---
            const calculatedTotalGoods = detail.totalGoods && detail.totalGoods > 0
                ? detail.totalGoods
                : (detail.totalCases || 0) * (detail.goodsPerCase || 0);

            // --- Cálculo seguro de cases por pallet ---
            const pallets = detail.palletsAmount === 0 ? 1 : detail.palletsAmount;
            const casesPerPallet = Math.floor((detail.totalCases || 0) / pallets);

            result.push([
                detail.id || "",
                detail.idInbound || "",
                detail.idGood || "",
                detail.idListPallet || "",
                detail.eanCode || "",
                detail.sku || "",
                detail.goodName || "",
                detail.palletsAmount || 0,
                casesPerPallet,
                detail.totalCases || 0,
                detail.goodsPerCase || 0,
                calculatedTotalGoods,
                detail.bestBeforeDate || "",
                detail.language || "",
                detail.documentation ? 1 : 0,
                detail.idListTypeInbounds || "",
                this.idUser
            ]);
        });

        const parameters: StringObjectTuple[] = [
            ["IdTransaction", idTransaction]
        ];

        const structures: StringObjectArrayListTuple[] = [
            ["InboundDetail", result]
        ];

        const api = new DataAcessApi("Inbounds6");

        try {
            await api.ExecStructuredProcedure('BOR_INBOUND_UPDATE_DETAIL', parameters, structures);
        } catch (error) {
            console.error('Error updating fields:', error);
            return false;
        }

        return true;
    }

    async Import(idTransaction: string, idInbound: string): Promise<boolean> {
        let parameters: StringObjectTuple[];
        parameters = [['IdTransaction', idTransaction], ['IdInbound', idInbound]];
        
        const api = new DataAcessApi("Inbounds7");
        try {
            await api.ExecStructuredProcedure('BOR_INBOUND_CONFIRM_DETAIL', parameters, []);
            await this.borTransactionsApi.UpdatedCompleted(idTransaction, 0, '');
        } catch (error) {
            await this.borTransactionsApi.UpdatedCompleted(idTransaction, 500, this.ParseToString(error));
            console.error('Error import inbound details:', error);
            return false;
        }
        return true;
    }
      
    ParseToString(value: unknown): string {
        if (typeof value === "string") {
            return value;
        }
        throw new Error("Value is not a string");
    }
    
    GetValidations(result: string): BORValidation[] {
        try {
            if (result === '') { return []; }
            const parsedResult = JSON.parse(result);
            if (!parsedResult.ValidationRecords || !Array.isArray(parsedResult.ValidationRecords)) {
                throw new Error("Invalid JSON format: Missing 'ValidationRecords' array");
            }
    
            return parsedResult.ValidationRecords.map((record: any) => ({
                ErrorCode: Number(record.ErrorCode) || 0,
                ErrorDescription: record.ErrorDescription || "",
                Solution: record.Solution || ""
            }));
        } catch (error) {
            console.error("Error parsing validation records:", error);
            return [];
        }
    }

    MapToBORInboundDetailType(data: IDataTable): IBORInboundDetailType[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }
        return data.records.map(record => {
            return {
                id: record.id || "",
                idInbound: record.idInbound || "",
                idGood: record.idGood || "",
                idListPallet: record.idListPallet || "",
                eanCode: record.eanCode || "",
                sku: record.sku || "",
                goodName: record.goodName || "",
                palletsAmount: Number(record.palletsAmount) || 0,
                casesPerPallet: Number(record.casesPerPallet) || 0,
                totalCases: Number(record.totalCases) || 0,
                goodsPerCase: Number(record.goodsPerCase) || 0,
                totalGoods: Number(record.totalGoods) || 0,
                bestBeforeDate: record.bestBeforeDate || "",
                language: record.language || "",
                documentation: Boolean(record.documentation),
                idListTypeInbounds: record.idListTypeInbounds || "",
                idPalletType: record.idPalletType || "",
                palletName: record.palletName || "",
                validationResult: record.validationResult || "",
                validations: this.GetValidations(record.validationResult),
                invalidCasesPerPallet: false
            };
        });
    }
}
